// extracted by mini-css-extract-plugin
export default {"chip":"delivery-create-modal_chip__uhSG5"};